import RFFInputField from '../../form/RFFInputField';

import { isWsdcSize } from '../../../utils/validationUtils';

// import {
//   isNationalItemIdentificationNumber,
//   composeValidatorsForNonRequired,
// } from '../../../utils/validationUtils';
// import { isNationalItemIdentificationNumber } from '../../FormBuilder/validators';

// const disableUnfocusedFields = () => {
//   const nodes = [...document.querySelectorAll('.nf-rff-input-field__input')];
//   const nodesByValue = nodes.filter(el => !el.value);
//   // 7 is the expected number of elements
//   if (nodesByValue.length !== 7) {
//     // eslint-disable-next-line
//     nodesByValue.map(el => (el.disabled = true));
//   } else {
//     // eslint-disable-next-line
//     nodes.map(el => (el.disabled = false));
//   }
// };

export default [
  {
    name: 'niin',
    label: 'NIIN',
    component: RFFInputField,
    placeholder: 'Enter a National Item Identification Number',
    // validate: composeValidatorsForNonRequired(
    //   isNationalItemIdentificationNumber,
    // ),
    // onKeyUp: disableUnfocusedFields,
    tooltip: 'Search by NIIN (00-456-7890)',
    inputCol: {
      md: 9,
    },
  },
  {
    name: 'partNum',
    label: 'Finished Part Number',
    placeholder: 'Enter a Finished Part Number',
    component: RFFInputField,
    hideInProcSearch: true,
    // onKeyUp: disableUnfocusedFields,
    tooltip: 'Part number designated by a Government Entity and is referenced as the official part number on original design data. (ex; 10895001)',
    inputCol: {
      md: 9,
    },
  },
  {
    name: 'description',
    label: ' Part Description',
    placeholder: 'Enter a Part Description',
    component: RFFInputField,
    hideInProcSearch: true,
    // onKeyUp: disableUnfocusedFields,
    tooltip: 'Search any words contained in the part description. The part descriptions are the same as the Item Name Codes specified by the Defense Logistics Information Systems (DLIS)',
    inputCol: {
      md: 9,
    },
  },
  {
    name: 'wsdc',
    label: 'Weapon System Designator Code',
    placeholder: 'Enter a WSDC',
    component: RFFInputField,
    // onKeyUp: disableUnfocusedFields,
    tooltip: 'WSDC is a two-position numeric code followed by a one position alpha Service Activity Code. Enter 2 or 3 positions.',
    validate: isWsdcSize,
    inputCol: {
      md: 9,
    },
  },
  {
    name: 'wsName',
    label: 'Weapon System Name',
    placeholder: 'Enter a Weapon System Name',
    component: RFFInputField,
    // onKeyUp: disableUnfocusedFields,
    tooltip: 'Search any words contained in the Weapon System Name.',
    inputCol: {
      md: 9,
    },
  },
  {
    name: 'searchCage',
    label: ' CAGE',
    placeholder: 'Enter Cage',
    component: RFFInputField,
    // onKeyUp: disableUnfocusedFields,
    tooltip: 'Search By Cage',
    inputCol: {
      md: 9,
    },
  },
  {
    name: 'solicitation',
    label: ' Solicitation Number',
    placeholder: 'Enter Solicitation Number',
    component: RFFInputField,
    // onKeyUp: disableUnfocusedFields,
    tooltip: 'Search by Solicitation Number',
    inputCol: {
      md: 9,
    },
  },


];



// WEBPACK FOOTER //
// ./src/components/forms/ToolingSearch/formConfig.jsx